module.exports = __webpack_public_path__ + "img/footer.b406ca5c.webp";